import { render, staticRenderFns } from "./TotalViews.vue?vue&type=template&id=50420d4e&scoped=true"
import script from "./TotalViews.vue?vue&type=script&lang=js"
export * from "./TotalViews.vue?vue&type=script&lang=js"
import style0 from "./TotalViews.vue?vue&type=style&index=0&id=50420d4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50420d4e",
  null
  
)

export default component.exports